import {useQuery} from 'react-query';
import getPrepaymentAuction from 'services/myAd/getSuggestions/auction/getprepaymentSuggestion';

const useGetPrepaymentAuction = (guid: string) => {
  const {data, isLoading} = useQuery(
    ['prepayment-Auction', guid],
    getPrepaymentAuction,
  );
  return {data, isLoading};
};

export default useGetPrepaymentAuction;
